import React from 'react';
import {useIntl} from 'react-intl';

import type {Channel} from '@mattermost/types/channels';

import Constants from 'utils/constants';

import {EditorWrapper} from './wrapper';

export const RestrictedChannel = ({channelType}: {channelType: Channel['type']}) => {
    const {formatMessage} = useIntl();

    const isDirectOrGroup = channelType === Constants.DM_CHANNEL || channelType === Constants.GM_CHANNEL;

    return (
        <EditorWrapper>
            {formatMessage({
                id: isDirectOrGroup ? 'editor_state.create_post_direct_or_group.off' : 'editor_state.create_post_channel.off',
                defaultMessage: isDirectOrGroup ? 'The chat is read-only' : 'The channel is read-only',
            })}
        </EditorWrapper>
    );
};
